import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
	lossReasonGroup: {
		display: "flex",
		alignItems: "center",
		flexWrap: "nowrap",
		gap: theme.spacing(0.5),
		minWidth: 0
	},
	lossReasonValueChip: {
		maxWidth: 180,
		minWidth: 0
	}
}))

export default useStyles
